import Layout from '@/layout'

const route = {
  path: '/recordStatistics',
  component: Layout,
  redirect: '/recordStatistics/index',
  alwaysShow: true, // will always show the root menu
  name: 'recordStatistics',
  meta: {
    title: '数据统计',
    icon: 'diy-UuJuTsJi',
    roles: [
      'report_form'
    ]
  },
  children: [
    {
      path: '/oldBindingRelation/index',
      component: () => import('@/views/oldBindingRelation/index.vue'),
      name: 'oldBindingRelation',
      meta: {
        title: '老号绑定关系',
        roles: [
          'sd.bind'
        ]
      }
    },
    {
      path: '/reportForm/index',
      component: () => import('@/views/reportForm/index.vue'),
      name: 'reportForm',
      meta: {
        title: '数据报表',
        roles: [
          'sd.report_form'
        ]
      }
    },
    {
      path: '/ladderdiagram/index',
      component: () => import('@/views/ladderdiagram/index.vue'),
      name: 'ladderdiagram',
      meta: {
        title: '订单二充T图表',
        roles: [
          'stsChargeReport.index'
        ]
      }
    }

  ]
}

export default route
